module.exports = __webpack_public_path__ + "img/symbol_18.e1623886.png";